import * as constants from '../constants/actions';

const initialState = {
	users: null,
	modalUser: null,
  modalOpen: false,
  customerCard: null,
  cardToEdit: null,
  selfUser: null,
  shareQueue: null,
  returnTo: null,
  pendingFetchDirectory: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.USERS_SAVE:
      return usersSave(state, action);
    case constants.USERS_MODAL_OPEN:
      return usersModalOpen(state, action);
    case constants.USERS_MODAL_CLOSE:
      return usersModalClose(state, action);
    case constants.USERS_SET_CUSTOMER_CARD:
      return usersSetCard(state, action);
    case constants.USERS_SET_SELF:
      return usersSetSelf(state, action);
    case constants.USERS_ADD_TO_SHARE_QUEUE:
      return usersAddToShareQueue(state, action);
    case constants.USERS_RETURN_TO:
      return usersSetReturnTo(state, action);
    case constants.USERS_CARD_TO_EDIT:
      return usersSetCardToEdit(state, action);
    case constants.USERS_FETCH_DIRECTORY_PENDING:
      return usersSetDirectoryPending(state, action);
    default:
      return state;
  }
}

function usersSetDirectoryPending(state, action) {
 return Object.assign({}, state, {
    pendingFetchDirectory: action.payload,
  });
}

function usersSave(state, action) {
  return Object.assign({}, state, {
    users: action.users
  });
}

function usersModalOpen(state, action) {
  return Object.assign({}, state, {
    modalOpen: true,
    modalUser: action.user
  });
}

function usersModalClose(state, action) {
  return Object.assign({}, state, {
    modalOpen: false,
  });
}

function usersSetCard(state, action) {
  return Object.assign({}, state, {
    customerCard: action.card,
  });
}

function usersSetSelf(state, action) {
  return Object.assign({}, state, {
    selfUser: action.user,
  });
}

function usersAddToShareQueue(state, action) {
  if(state.shareQueue === null) {
    return Object.assign({}, state, {
      shareQueue: action.diamonds,
      returnTo: action.page,
    });
  } else {
    let clone = [];
    for(let n = 0; n < state.shareQueue.length; n++) {
      clone[n] = state.shareQueue[n];
    }
    let combined = clone.concat(action.diamonds);
    return Object.assign({}, state, {
      shareQueue: combined,
      returnTo: action.page,
    });
  }
}

function usersSetReturnTo(state, action) {
  return Object.assign({}, state, {
    returnTo: action.page,
  });
}

function usersSetCardToEdit(state, action) {
  return Object.assign({}, state, {
    cardToEdit: action.card,
  });
}